import { Component, OnInit, ViewChild, Pipe, AfterViewInit } from '@angular/core';
import { SrubUpService } from '../Services/ScrubUp.service';
import { TooltipPosition } from '@angular/material/tooltip';
import { CookieService } from 'ngx-cookie-service';
import { AppWideUser, Token } from '../Services/AppUserProfile';
import { DataSource } from '@angular/cdk/collections';
import { MatSort, Sort, MatTableModule, MatSortModule } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { MatPaginatorModule } from '@angular/material/paginator';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Observable } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { map, tap } from 'rxjs/operators';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { merge } from 'rxjs/observable/merge';
interface USERROLE {
  RoleName: string;
  RoleCategory: string;
  IOSCount: string;
  AndroidCount: string
}
@Component({
  selector: 'app-procedure-report',
  templateUrl: './procedure-report.component.html',
  styleUrls: ['./procedure-report.component.scss'],
  providers: [SrubUpService]
})
export class ProcedureReportComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['ProcedureName', 'SpecialityName', 'AssignedToSurgeon', 'Downloads'];
  dataSource: eDataSource;
  ELEMENT_DATA: USERROLE[] = [];
  data: any = [];
  interval: number | undefined;
  specialityId: any;
  public loading = false;
  specialities: any = [];
  loginUserId: number;
  sprocedure: any = [];
  row: any = [];
  selectedValue = '';
  specialitynamedefault = '';
  totalRecords = 0;
  pagesize = 10;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort;
  form: FormGroup = new FormGroup({});
 
  constructor(private fb: FormBuilder, private cookieService: CookieService, private appUser: AppWideUser, private token: Token, private scrubUpService: SrubUpService) {
    if (this.appUser.UserName == undefined && this.token.access_token == undefined || this.appUser.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUser = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }
    this.loginUserId = this.appUser.UserId;
  }

  //use for pagination
  ngAfterViewInit() {
   // console.log("test");
    //this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.GetSPecialityProcedure(this.selectedValue))
      )
      .subscribe();
  }

  ngOnInit() {
    this.GetSpecialities();
  }
  
  //use for listing speciality in dropdown
  GetSpecialities() {
    this.loading = true;
    this.scrubUpService.GetSpecialities(this.token, this.loginUserId, true).subscribe(x => {
      if (x['Data'] != null && x != undefined) {
        this.specialities = x['Data'];
        this.selectedValue = this.specialities[0]['ID'];
        this.GetSPecialityProcedure(this.selectedValue);
        this.form = this.fb.group({
          specialitynamedefault: [this.selectedValue],
        });
      }
    },
      error => {
        this.loading = false;
      })
  }

//use for get procedure which speciality select
  GetSPecialityProcedure(id) {
    this.data=[];
    this.loading = true;
    let pageindex = 0;
    if (this.paginator.pageIndex == 0) {
      pageindex = 0;
    }
    else {
      pageindex = this.paginator.pageIndex;
    }

    this.scrubUpService.GetsprocedureReport(this.token, id, pageindex, 10).subscribe(x => {
      if (x['Data'] != null && x['Status'] != undefined) {
        this.data = x['Data']['AdminReportsProcedures'];
        this.dataSource = new eDataSource(this.data);
        this.totalRecords = x['Data']['totalRecords'];
        this.pagesize =10;
        this.announceSortChange(this.sort);
      }
      else {
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction == 'asc') {
      this.data.sort((a, b) => a[sortState.active] > b[sortState.active] ? 1 : a[sortState.active] < b[sortState.active] ? -1 : 0);
      return this.dataSource = new eDataSource(this.data);
    } else {
      this.data.sort((a, b) => a[sortState.active] < b[sortState.active] ? 1 : a[sortState.active] > b[sortState.active] ? -1 : 0);
      return this.dataSource = new eDataSource(this.data);
    }
  }

  //use for speciality dropdown change event 
  onchange(id) {
    this.paginator.pageIndex = 0;
    this.GetSPecialityProcedure(id);
  }

}
export class eDataSource extends DataSource<any> {

  constructor(private element: Element[]) {
    super();
  }

  connect(): Observable<Element[]> {
    return Observable.of(this.element);
  }

  disconnect() { }

}


// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/procedure-report/procedure-report.component.ts